module.exports = __webpack_public_path__ + "082ed7121afed84aae5079ba405b12ee.jpg";